import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { useSmoothScroll } from "@/lib/useSmoothScroll";
import { ScrollToTop } from "@/components/site/ScrollToTop";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Leadership from "@/pages/Leadership";
import Services from "@/pages/Services";
import AssetClasses from "@/pages/AssetClasses";
import ServiceDetail from "@/pages/ServiceDetail";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/leadership" element={<Leadership />} />
            <Route path="/services" element={<Services />} />
            <Route path="/asset-classes" element={<AssetClasses />} />
            <Route path="/property-management" element={<ServiceDetail slug="property-management" />} />
            <Route path="/asset-management" element={<ServiceDetail slug="asset-management" />} />
            <Route path="/hospitality-management" element={<ServiceDetail slug="hospitality-management" />} />
            <Route path="/portfolio-transition" element={<ServiceDetail slug="portfolio-transition" />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Legal kind="privacy" />} />
            <Route path="/terms" element={<Legal kind="terms" />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <Toaster theme="light" position="bottom-right" richColors />
      </BrowserRouter>
    </div>
  );
}

const SmoothScroll = () => {
  useSmoothScroll();
  return null;
};

export default App;
